var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 244.02 59.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bafa451c-eabd-4477-aeec-7371162432c2{fill:none;stroke:#89a6df;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e41cf31d-5ab9-43cf-8c48-59615a352006",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bafa451c-eabd-4477-aeec-7371162432c2",
    d: "M225.17,13.65l-54.34,32.6a3.66,3.66,0,0,1-3.69,0L109.77,13.59a3.68,3.68,0,0,0-1.81-.48H18.85"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.c5dfc92e.svg";
export { ForwardRef as ReactComponent };